// UtilityButton.tsx
import React from 'react';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import { UtilityButtonProps } from 'types/UtilityButtonProps';

const PrimaryButton: React.FC<UtilityButtonProps> = ({
  label,
  size,
  onClick,
  disabled = false,
  type = 'button',
  className,
}) => {
  return (
    <Button
      className={`text-light ${className}`}
      variant="primary"
      size={size}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {label}
    </Button>
  );
};

export default PrimaryButton;
